<template>
  <div>

  </div>
</template>

<script>
    // import Wordcloud from "wordcloud"
    export default {
        name: "Edit",
        data() {
        },
        components: {},
        mounted() {
        },
        methods: {}
    }
</script>
<style type="text/less" lang="less" scoped>

</style>
